module.exports = __webpack_public_path__ + "img/earth_specular_2048.7dd1857a.jpg";